import { render, staticRenderFns } from "./SlideshowBanner.vue?vue&type=template&id=c606ae18&scoped=true&functional=true&"
import script from "./SlideshowBanner.vue?vue&type=script&lang=js&"
export * from "./SlideshowBanner.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowBanner.vue?vue&type=style&index=0&id=c606ae18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "c606ae18",
  null
  
)

export default component.exports